import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Parse a date string safely, handling date-only strings (YYYY-MM-DD)
 * as local dates instead of UTC to prevent off-by-one timezone issues.
 */
export function parseLocalDate(dateStr: string): Date {
  // Date-only strings like "2026-04-04" are parsed as UTC by default,
  // causing off-by-one in timezones behind UTC. Replace hyphens with
  // slashes so the Date constructor treats it as local time.
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    return new Date(dateStr.replace(/-/g, '/'));
  }
  return new Date(dateStr);
}

type FormatAstMode = "short" | "long";

export function formatAST(value: string | Date | null | undefined, mode: FormatAstMode = "short"): string {
  if (!value) return "—";

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "—";

  const options: Intl.DateTimeFormatOptions = mode === "long"
    ? {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      }
    : {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      };

  return new Intl.DateTimeFormat("en-GB", options).format(date);
}
